import {
  fetchWithFirebaseAuth,
  getSbsApiErrorMessage,
} from "../../utils/sbsApiClient";

const SUPPORT_API_BASE = (
  process.env.REACT_APP_SBS_TOOLS_API_URL ||
  (process.env.NODE_ENV === "development"
    ? "https://us-central1-selenne-business-suite.cloudfunctions.net/sbsToolsApi"
    : "")
).replace(/\/$/, "");

function supportApiUrl(path) {
  return `${SUPPORT_API_BASE}${path}`;
}

async function callSupportApi(path, body, fallback) {
  const response = await fetchWithFirebaseAuth(supportApiUrl(path), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(getSbsApiErrorMessage(response.status, payload, fallback));
  }
  return payload;
}

export function askDerick(input) {
  return callSupportApi(
    "/api/support-assistant/chat",
    input,
    "Derick could not answer right now."
  );
}

export function createSupportTicket(input) {
  return callSupportApi(
    "/api/support/tickets",
    input,
    "The support ticket could not be sent."
  );
}
